import { getBadgeTitle } from "./badges";

const notifications = {
    FREE: {
        generic: (t, args) => t('{{content}}', args),
    },

    // Community recomended brickfilms
    DISCOVER_BRICKFILM_MONTH: {
        generic: (t, args) => t('Discover "[b]{{brickfilm_title}}[/b]" by {{brickfilm_author_login}}, last month\'s best brickfilm.', args),
    },
    DISCOVER_BRICKFILM_WEEK: {
        generic: (t, args) => t('Discover "[b]{{brickfilm_title}}[/b]" by {{brickfilm_author_login}}, the most promising brickfilm of the week.', args),
    },
    DISCOVER_BRICKFILM_RECOMMENDED: {
        generic: (t, args) => t('The community recommends "[b]{{brickfilm_title}}[/b]".', args),
    },

    // Articles
    ARTICLE_PUBLISHED: {
        generic: (t, args) => t('The article "[b]{{article_title}}[/b]" has been published, go check it out!', args),
    },
    ARTICLE_EDITED: {
        generic: (t, args) => t('The article "[b]{{article_title}}[/b]" has been edited.', args),
    },
    ARTICLE_PENDING: {
        generic: (t, args) => t('The article "[b]{{article_title}}[/b]" is awaiting moderation.', args),
    },

    // Brickfilms
    BRICKFILM_PUBLISHED: {
        generic: (t, args) => t('[b]{{brickfilm_author_login}}[/b] just published the brickfilm "[b]{{brickfilm_title}}[/b]".', args),
    },
    BRICKFILM_RELEASED: {
        generic: (t, args) => t('[b]{{brickfilm_title}}[/b], the latest brickfilm by {{brickfilm_author_login}} has been published.', args),
    },
    BRICKFILM_EDITED: {
        generic: (t, args) => t('[b]{{brickfilm_author_login}}[/b] has updated the brickfilm "[b]{{brickfilm_title}}[/b]".', args),
    },
    BRICKFILM_MAKINGOF_ADDED: {
        generic: (t, args) => t('[b]{{brickfilm_author_login}}[/b] has added a making-of about the brickfilm project "[b]{{brickfilm_title}}[/b]".', args),
    },

    // Project brickfilm
    PROJECT_PUBLISHED: {
        generic: (t, args) => t('[b]{{brickfilm_author_login}}[/b] just published the brickfilm project "[b]{{brickfilm_title}}[/b]".', args),
    },
    PROJECT_EDITED: {
        generic: (t, args) => t('[b]{{brickfilm_author_login}}[/b] has updated the brickfilm project "[b]{{brickfilm_title}}[/b]".', args),
    },
    PROJECT_TEASER_RELEASED: {
        generic: (t, args) => t('[b]{{brickfilm_author_login}}[/b] has added a teaser about the brickfilm project "[b]{{brickfilm_title}}[/b]".', args),
    },
    PROJECT_PRODUCTION_ADDED: {
        generic: (t, args) => t('[b]{{brickfilm_author_login}}[/b] has added a production note about the brickfilm project "[b]{{brickfilm_title}}[/b]".', args),
    },

    // Resources
    RESOURCE_PUBLISHED: {
        generic: (t, args) => t('[b]{{resource_author_login}}[/b] just published the resource "[b]{{resource_title}}[/b]".', args),
    },
    RESOURCE_EDITED: {
        generic: (t, args) => t('[b]{{resource_author_login}}[/b] has updated the resource "[b]{{resource_title}}[/b]".', args),
    },

    // Badges
    BADGE_RECEIVED: {
        feed: (t, args) => t('[b]{{user_login}}[/b] just obtained the badge "[b]{{badge_title}}[/b]".', {
            ...args,
            badge_title: getBadgeTitle(args?.badge_id, t)
        }),
        notification: (t, args) => t('You just obtained the badge "[b]{{badge_title}}[/b]", it will now show up on your profile page.', {
            ...args,
            badge_title: getBadgeTitle(args?.badge_id, t)
        }),
    },

    // Users
    USER_SUBSCRIBED: {
        feed: (t, args) => t('[b]{{user_login}}[/b] has subscribed to [b]{{subscriber_login}}[/b], they will be informed of new publications.', args),
        notification: (t, args) => t('[b]{{user_login}}[/b] has subscribed to you, they will be informed of your new publications.', args),
    },
    USER_REGISTERED: {
        generic: (t, args) => t('[b]{{user_login}}[/b] just joined the community, welcome!', args),
    },
    USER_BUY_PREMIUM: {
        feed: (t, args) => t('[b]{{user_login}}[/b] subscribed to the premium plan. Thanks for your support!', args),
        notification: (t, args) => t('You are now [b]premium[/b], thank you for supporting the community!', args),
    },
    USER_BUY_DONATOR: {
        feed: (t, args) => t('[b]{{user_login}}[/b] subscribed to the donator plan. Thanks for your support!', args),
        notification: (t, args) => t('You are now [b]donator[/b], thank you for supporting the community!', args),
    },
    USER_RECEIVED_BOOSTS: {
        notification: (t, args) => {
            if (parseInt(args.number_of_boosts, 10) > 1) {
                return t('You have received [b]{{number_of_boosts}} brickfilm boosts[/b], boost your brickfilms to highlight them on the website.', args);
            }
            if (parseInt(args.number_of_boosts, 10) === 1) {
                return t('You have received [b]one brickfilm boost[/b], boost your brickfilms to highlight them on the website.', args);
            }
            return t('You have received [b]{{number_of_boosts}} brickfilm boost[/b], boost your brickfilms to highlight them on the website.', args);
        }
    },

    // Contest
    CONTEST_REGISTERED: {
        generic: (t, args) => t('[b]{{user_login}}[/b] has just entered the "[b]{{contest_title}}[/b]" contest with "[b]{{brickfilm_title}}[/b]".', args),
    },

    // Messages
    MESSAGE_ADDED: {
        feed: (t, args) => args.message_first === 'true' ? t('[b]{{message_author_login}}[/b] posted {{kind}} "[b]{{parent_title}}[/b]".', args) : t('[b]{{message_author_login}}[/b] replied {{kind}} "[b]{{parent_title}}[/b]".', args),
        notification: (t, args) => t('New messages have been posted {{kind}} "[b]{{parent_title}}[/b]".', args),
    },
    MESSAGE_DELETED: {
        feed: (t, args) => t('The message by [b]{{message_author_login}}[/b] {{kind}} "[b]{{parent_title}}[/b]" has been deleted.', args),
        notification: (t, args) => t('Your message posted {{kind}} "[b]{{parent_title}}[/b]" has been deleted.', args),
    },
    MESSAGE_EDITED: {
        feed: (t, args) => t('The message by [b]{{message_author_login}}[/b] {{kind}} "[b]{{parent_title}}[/b]" has been edited.', args),
        notification: (t, args) => t('Your message posted {{kind}} "[b]{{parent_title}}[/b]" has been edited.', args),
    },
    MESSAGE_LIKED: {
        feed: (t, args) => t('The message by [b]{{message_author_login}}[/b] {{kind}} "[b]{{parent_title}}[/b]" has been liked.', args),
        notification: (t, args) => t('Your message posted {{kind}} "[b]{{parent_title}}[/b]" has been liked.', args),
    },
    MESSAGE_UNLIKED: {
        feed: (t, args) => t('The message by [b]{{message_author_login}}[/b] {{kind}} "[b]{{parent_title}}[/b]" is no longer liked.', args),
        notification: (t, args) => t('Your message posted {{kind}} "[b]{{parent_title}}[/b]" is no longer liked.', args),
    },
    MESSAGE_RESTORED: {
        feed: (t, args) => t('The message by [b]{{message_author_login}}[/b] posted {{kind}} "[b]{{parent_title}}[/b]" has been restored.', args),
        notification: (t, args) => t('Your message posted {{kind}} "[b]{{parent_title}}[/b]" has been restored.', args),
    },
    MESSAGE_DESTROYED: {
        feed: (t, args) => t('The message by [b]{{message_author_login}}[/b] posted {{kind}} "[b]{{parent_title}}[/b]" has been destroyed.', args),
        notification: (t, args) => t('Your message posted {{kind}} "[b]{{parent_title}}[/b]" has been destroyed.', args),
    },
    MESSAGE_QUOTED: {
        notification: (t, args) => t('You have been mentioned {{kind}} "[b]{{parent_title}}[/b]".', args),
    },

    GENERATOR_DONE: {
        notification: (t, args) => t('Your customized video is ready, you can download it from the opening generator.', args),
    },
};

const parentTypes = {
    BRICKFILM: (t) => t('on the brickfilm'),
    ARTICLE: (t) => t('on the article'),
    THREAD: (t) => t('on the thread'),
    PROJECT: (t) => t('on the project'),
    RESOURCE: (t) => t('on the resource'),
    UNKNOWN: (t) => t('on the document'),
}

// mode === FEED // NOTIFICATION
export const getNotificationText = (t, type, args, mode) => {
    const func = notifications[type];
    let convertedArgs = args.reduce((acc, e) => ({ ...acc, [e.name]: e.value }), {});

    // Add sub translation for message kind
    if (type.startsWith('MESSAGE_')) {
        convertedArgs.kind = parentTypes?.[convertedArgs.parent_type]?.(t) || parentTypes.UNKNOWN(t);
    }

    // Anonymous user
    if (convertedArgs.message_author_login === null) {
        convertedArgs.message_author_login = t('Anonymous');
    }

    return func?.[mode.toLowerCase()]?.(t, convertedArgs) || func?.generic?.(t, convertedArgs) || null;
}
